
export const portfolioCategories = ['All', 'Technology', 'Food & Hospitality', 'Beauty & Wellness', 'Print & Media'];

export const portfolioProjects = [
  {
    name: 'YIAN COMPANY',
    category: 'Technology',
    description: 'BeautyTech platform connecting clients with professional makeup artists — featuring AI-powered artist matching, mobile services, and real-time booking across Connecticut.',
    image: 'https://api.apiflash.com/v1/urltoimage?access_key=c46a39e396f04d1e9e1e5e8e5e8e5e8e&url=https://yianco.com&width=1200&height=900&fresh=true',
    url: 'https://yianco.com'
  },
  {
    name: 'J\'ADORE BRUNCH',
    category: 'Food & Hospitality',
    description: 'Elegant brunch reservation platform offering curated dining experiences with bottomless mimosas, beautiful plating, and a polished social atmosphere.',
    image: 'https://api.apiflash.com/v1/urltoimage?access_key=c46a39e396f04d1e9e1e5e8e5e8e5e8e&url=https://jadorebrunch.com&width=1200&height=900&fresh=true',
    url: 'https://jadorebrunch.com'
  },
  {
    name: 'TRANSFORMATIONS',
    category: 'Beauty & Wellness',
    description: 'Premium skincare and wellness studio specializing in personalized treatments, holistic skin care, and transformative beauty services.',
    image: 'https://api.apiflash.com/v1/urltoimage?access_key=c46a39e396f04d1e9e1e5e8e5e8e5e8e&url=https://transformations.readdy.co&width=1200&height=900&fresh=true',
    url: 'https://transformations.readdy.co'
  },
  {
    name: 'HOT OFF THE PRESS',
    category: 'Print & Media',
    description: 'Professional printing service delivering high-quality flyers, brochures, business cards, and custom print materials with same-day availability.',
    image: 'https://api.apiflash.com/v1/urltoimage?access_key=c46a39e396f04d1e9e1e5e8e5e8e5e8e&url=https://hotoffthepress.readdy.co&width=1200&height=900&fresh=true',
    url: 'https://hotoffthepress.readdy.co'
  }
];
